import { action, makeAutoObservable, observable } from "mobx"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import type {
  IInquiryFeeTypeSetting,
  IInquiryFeeTypeSettingFilter,
  ICreateUpdateInquiryFeeTypeSetting,
} from "@models/receiptType/receiptTypeModel"
import InquiryFeeTypeSettingService from "@services/receiptType/inquiryFeeTypeSettingService"

class InquiryFeeTypeSettingStore {
  @observable isLoading: boolean = false
  @observable tableData: PagedResultDto<IInquiryFeeTypeSetting> = {
    items: [],
    totalCount: 0,
  }
  @observable detailData: IInquiryFeeTypeSetting | null = null
  @observable listReceiptType: IInquiryFeeTypeSetting[] = []

  constructor() {
    makeAutoObservable(this)
  }

  @action
  async getAll(params: IInquiryFeeTypeSettingFilter) {
    this.isLoading = true
    const result = await InquiryFeeTypeSettingService.getAll(params).finally(
      () => (this.isLoading = false)
    )
    this.tableData = result
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await InquiryFeeTypeSettingService.get(id).finally(
      () => (this.isLoading = false)
    )
    this.detailData = result
    return result
  }

  @action
  async createOrUpdate(body: ICreateUpdateInquiryFeeTypeSetting) {
    this.isLoading = true
    const result = await InquiryFeeTypeSettingService.createOrUpdate(
      body
    ).finally(() => (this.isLoading = false))
    this.detailData = result
    return result
  }

  @action
  async delete(id: number) {
    this.isLoading = true
    await InquiryFeeTypeSettingService.delete(id).finally(
      () => (this.isLoading = false)
    )
  }

  @action
  async getList(objectType?: number) {
    const result = await InquiryFeeTypeSettingService.getList(objectType)
    this.listReceiptType = result
    return result
  }
}

export default InquiryFeeTypeSettingStore
